import React, { useState, useEffect } from "react";
// styles
import "../pages.css";
// utils
import XGridDemo from "../../components/utils/grid/Xgrid";
import TransitionModal from "../../components/utils/modals/Modals";
import Buttons from '../../components/utils/buttonsContainer/Buttons';
// consts
import { zonasDeNoEnroll as titles } from "../../consts/titulos-de-tablas";
import { modalsInfoZonaDeNoEnroll as infoModal } from "../../consts/Modals-info";
//Assets
import CircularIndeterminate from '../../components/utils/spinner/Spinner';
//Services 
import { retrieveData } from '../../services/Local-services';
import { zonasDeNoEnrollGet } from '../../services/hooli-services/ZonasDeNoEnroll/ZonasDeNoEnrollGet';
// recoil
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { userCredentials, rowSelected, formData } from '../../recoilState/GlobalState';

export default function ZonasDeNoEnroll({ route }) {
    const [zonasDeNoEnroll, setZonasDeNoEnroll] = useState([]);
    const [rows, setRows] = useState([]);
    const [action, setAction] = useState({});
    const [cargando, setCargando] = useState(true);

    const setRow = useSetRecoilState(rowSelected)
    const credentials = useRecoilValue(userCredentials);
    const setFormInfo = useSetRecoilState(formData);

    const updateList = async () => {
        setCargando(true);
        await retrieveData(credentials, setRows, zonasDeNoEnrollGet, setZonasDeNoEnroll)
        setCargando(false);
    };

    useEffect(() => {
        if (Object.keys(credentials).length > 0) updateList()
    }, [credentials]);

    useEffect(() => {
        zonasDeNoEnroll.map((item) => {
            const {
                zonaNoEnrollId,
                zonaNoEnrollNombre,
                zonaNoEnrollVersion,
                zonaNoEnrollCoordenadas
            } = item

            const zona = {
                id: zonaNoEnrollId,
                version: zonaNoEnrollVersion,
                coordenadas: zonaNoEnrollCoordenadas,
                [titles[0]]: zonaNoEnrollNombre,
            }

            setRows(rows => [...rows, zona])
            return item
        });
    }, [zonasDeNoEnroll]);

    useEffect(() => setRow({ status: false }), [])

    const handleClick = ({ action, procede }) => {
        setFormInfo(infoModal[action]);
        setAction({ action, procede });
    };

    return (
        <main className="container">
            <TransitionModal
                titles={titles}
                procede={action.procede}
                updateList={updateList}
            />
            <Buttons texto="zona de no enroll" handleClick={handleClick} updateList={updateList} />
            <div className="row-grid" >
                {cargando ? <CircularIndeterminate /> : <XGridDemo rows={rows} titles={titles} />}
            </div>
        </main>
    )
};